import { useAuth } from "../contexts/AuthProvider";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { FEATURE_FLAGS } from "../contexts/FeatureFlagsProvider";
import { useWeekIndex } from "../contexts/WeekIndexProvider";
import { DEFAULT_WEEK_START_DAY } from "../utils/models";
import { isHeadNurse } from "../utils/utilFunctions";
import { useFeatureFlag } from "./useOpenFeatureFlag";

/** The weekday (0=Sun..6=Sat) the viewer's weeks start on: their own pick with dynamic week start, else Sunday, as the grid. */
export const useScheduleStartDay = (): number => {
	const { viewStartDay } = useWeekIndex();
	const isDynamicWeekStartEnabled = useFeatureFlag(FEATURE_FLAGS.StaffingDynamicWeekStart);
	return isDynamicWeekStartEnabled ? viewStartDay : DEFAULT_WEEK_START_DAY;
};

/** Whether the schedule cache may ask the server: the flag is on and the user is in admin view, which the endpoint requires. */
export const useScheduleCacheEnabled = (): boolean => {
	const { userInfo } = useAuth();
	const { chosenDepartment } = useChosenDepartment();
	const isScheduleCacheEnabled = useFeatureFlag(FEATURE_FLAGS.StaffingScheduleCache);
	return isScheduleCacheEnabled && isHeadNurse(userInfo.role) && chosenDepartment.department_id !== "";
};
